if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('span');
        this.hideErrors = this.dataset.hideErrors === 'true';

        const variantInput = this.form?.querySelector('[name="id"]');
        if (variantInput) variantInput.disabled = false;

        this.form?.addEventListener('submit', this.onSubmitHandler.bind(this));
      }

      async onSubmitHandler(event) {
        event.preventDefault();
        event.stopPropagation();

        if (!this.form || !this.submitButton) return;
        if (this.submitButton.disabled || this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const info = this.closest('product-info');
        const sizePicker = info?.querySelector('.pcsize');
        const selectedSize = info?.querySelector('variant-selects select[name^="options["]')?.value || '';
        if (sizePicker && /^Özel\s/i.test(selectedSize)) {
          let sizes = [];
          try { sizes = JSON.parse(sizePicker.querySelector('.pcsize__variant-data')?.textContent || '[]'); } catch (_) {}
          const selected = sizes.find((size) => size.value === selectedSize);
          if (info.classList.contains('pcsize-invalid') || !selected?.available || String(selected.id) !== String(this.variantIdInput?.value)) {
            this.handleErrorMessage('Ölçü seçimi henüz tamamlanmadı. Lütfen ölçüyü kontrol edip tekrar deneyin.');
            return;
          }
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner')?.classList.remove('hidden');

        const campaignActive = !!window.PatikassoCampaign?.isActive?.();
        const cartNotification = document.querySelector('cart-notification');
        const useNotification =
          campaignActive &&
          cartNotification &&
          typeof cartNotification.renderContents === 'function';

        const formData = new FormData(this.form);
        const operationId = window.crypto?.randomUUID?.() || Date.now() + '-' + Math.random().toString(36).slice(2);

        if (useNotification) {
          const sections = cartNotification.getSectionsToRender().map((section) => section.id);
          formData.append('sections', sections.join(','));
          formData.append('sections_url', window.location.pathname);
          cartNotification.setActiveElement?.(document.activeElement);
        } else {
          formData.append('sections', 'cart-icon-bubble');
          formData.append('sections_url', window.location.pathname);
        }

        try {
          const response = await fetch(window.routes.cart_add_url, {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              Accept: 'application/json',
            },
            body: formData,
          });

          const data = await response.json();

          if (!response.ok || data.status) {
            const message = data.description || data.message || 'Ürün sepete eklenemedi.';
            this.handleErrorMessage(message);
            return;
          }

          if (useNotification && data.sections) {
            cartNotification.renderContents(data);
          } else {
            const cartBubble = document.getElementById('cart-icon-bubble');
            const bubbleHtml = data.sections?.['cart-icon-bubble'];

            if (cartBubble && bubbleHtml) {
              const doc = new DOMParser().parseFromString(bubbleHtml, 'text/html');
              const freshBubble = doc.getElementById('cart-icon-bubble');
              if (freshBubble) cartBubble.innerHTML = freshBubble.innerHTML;
            }
          }

          document.dispatchEvent(
            new CustomEvent('patikasso:cart-added', {
              bubbles: true,
              detail: {
                variantId: formData.get('id'),
                campaignActive,
                operationId,
                quantity: Number(formData.get('quantity') || 1),
                lineItemKey: String(data.key || ''),
              },
            })
          );
        } catch (error) {
          console.error(error);
          this.handleErrorMessage('Ürün sepete eklenirken bir hata oluştu.');
        } finally {
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner')?.classList.add('hidden');
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        const wrapper = this.querySelector('.product-form__error-message-wrapper');
        const message = wrapper?.querySelector('.product-form__error-message');

        if (!wrapper || !message) return;

        wrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) message.textContent = errorMessage;
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.submitButtonText) this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form?.querySelector('[name="id"]');
      }
    }
  );
}

